import { ValidationError } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ValidatorError';
import { Validator, VARIABLE_VALIDATION_REGEX } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
export class ExecuteTemplateActionSettingsValidator extends Validator {
    validate(model) {
        if (model.inputVariables) {
            model.inputVariables.forEach(inputVariable => {
                if (!inputVariable.match(VARIABLE_VALIDATION_REGEX)) {
                    throw new ValidationError('The script input variable name should be composed only by letters, numbers and dots');
                }
            });
        }
        if (!model.template) {
            throw new ValidationError('The template is required');
        }
        if (!model.outputVariable) {
            throw new ValidationError('The template output variable is required');
        }
        if (!model.outputVariable.match(VARIABLE_VALIDATION_REGEX)) {
            throw new ValidationError('The template output variable name should be composed only by letters, numbers and dots');
        }
    }
}
